import React from 'react'
import './Community.css'
export default function DeletePostPopup({ handleDeletePostPopUpFalse }) {
    return (
        <div className='ContainerCreateDeleteCommunity'>
            <div className='SubContainerCreateDeleteCommunity'>
                <div onClick={handleDeletePostPopUpFalse}>
                    <img style={{ cursor: 'pointer' }} className='CrossIconPost' src='/Enggagement/crossCirclePost.png' alt=''></img>
                </div>
                <div className='d-flex justify-content-center msgDeleteHeading'>
                    Are you sure you want to delete this post?
                </div>
                <div className='d-flex gap-3 mt-4 pt-4 justify-content-center'>
                    <button className='DeleteYesBtn' onClick={handleDeletePostPopUpFalse}>Yes</button>
                    <button className='DeleteNoBtn' onClick={handleDeletePostPopUpFalse}>No</button>
                </div>
            </div>
        </div>
    )
}
